var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import dayjs from 'dayjs';
import { InsertionOrderRepository } from '@/models/InsertionOrder';
import { calcWholePeriodOfBudgets, getCampaignBudgets, factoryCampaign, InsertionOrderBudgetFormModel, genRequestParams, InventoryListGettingFormModel, } from '.';
import getInsertionOrderBudgetViolations from './getInsertionOrderBudgetViolations';
import { InventoryListTargetingUsePolicies, IP_AREA_JP_ID } from '../Constants';
import { InventoryListTargetingModel } from '@/models/InventoryListTargeting';
import { CampaignRepository } from '../CampaignRepository';
import { TemporaryCampaignRepository } from '../TemporaryCampaignRepository';
import { CampaignSaveIncompleteError } from '../Error';
import MasterApi from '../../../api/master';
import { SimulatableCreativeTypes, SimulatableMenuTypes, } from '@/models/Simulation/Constants';
import { MenuTypes } from '@/models/Menu/Constants';
/**
 * キャンペーン作成・編集フォーム共通フォームモデル
 */
var CompoundCampaignFormModel = /** @class */ (function () {
    function CompoundCampaignFormModel(item, systemOwner, advertiser, insertionOrder) {
        if (item === void 0) { item = {}; }
        var _a = item, campaign = _a.campaign, menuSetting = _a.menuSetting, demographicSetting = _a.demographicSetting;
        this.advertiserId = advertiser.id;
        this.insertionOrderId = insertionOrder.id;
        this.systemOwner = systemOwner;
        this.advertiser = advertiser;
        this.insertionOrder = insertionOrder;
        this.campaign = factoryCampaign(campaign, menuSetting, this.profileIds, demographicSetting);
        this.insertionOrderBudgets = [];
        this.menus = [];
        this.inventoryListTargetings = [];
        this.inventoryRequiredLists = new InventoryListGettingFormModel();
        this.inventoryOptionalLists = new InventoryListGettingFormModel();
        this.selectedBlackInventoryListOptionalIds = [];
        this.ipAreaRegions = [];
        this.enableCreative = true;
        this.isSubmited = false;
    }
    Object.defineProperty(CompoundCampaignFormModel.prototype, "isNew", {
        get: function () {
            return this.campaign.isNew;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompoundCampaignFormModel.prototype, "profileIds", {
        get: function () {
            return {
                systemOwnerProfileId: this.systemOwner.ownerProfileId,
                advertiserOwnerProfileId: this.advertiser.ownerProfileId,
                insertionOrderOwnerProfileId: this.insertionOrder.ownerProfileId,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompoundCampaignFormModel.prototype, "outOfMenuPeriodViolation", {
        /**
         * メニュー配信期間が予算設定した期間に被っていないかどうか
         * @param {MenuModel} menu
         * @return {boolean}
         */
        get: function () {
            var menu = this.campaign.menu;
            if ((menu === null || menu === void 0 ? void 0 : menu.startDate) == null && (menu === null || menu === void 0 ? void 0 : menu.endDate) == null)
                return false;
            var period = this.wholePeriodOfBudgets;
            var start = dayjs(period.startTime);
            var end = dayjs(period.endTime);
            var menuStart = (menu === null || menu === void 0 ? void 0 : menu.startDate) == null ? start : dayjs(menu === null || menu === void 0 ? void 0 : menu.startDate);
            var menuEnd = (menu === null || menu === void 0 ? void 0 : menu.endDate) == null ? end.add(1, 'second') : dayjs(menu === null || menu === void 0 ? void 0 : menu.endDate);
            return !((start.isSame(menuStart) || start.isAfter(menuStart)) &&
                start.isBefore(menuEnd));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompoundCampaignFormModel.prototype, "selectedMenu", {
        get: function () {
            var _this = this;
            return this.menus.find(function (menu) { return menu.id === _this.campaign.menuId; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompoundCampaignFormModel.prototype, "hasInvalidBudget", {
        get: function () {
            var _this = this;
            return this.insertionOrderBudgets
                .map(function (budget) {
                return getInsertionOrderBudgetViolations(budget, _this.campaign.mergedCampaignBudgets);
            })
                .flat()
                .some(function (error) { return error.reversePeriod || error.overlapping.length > 0; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompoundCampaignFormModel.prototype, "isSimulatable", {
        get: function () {
            if (this.isSubmited) {
                return false;
            }
            if (!this.menus.length) {
                return false;
            }
            // キャンペーンの設定に誤りがある場合を実行しない
            if (!this.campaign.isSimulatable) {
                return false;
            }
            // キャンペーン予算設定に誤りがある場合は実行しない
            if (this.hasInvalidBudget) {
                return false;
            }
            // シミュレーション可能なクリエイティブが選択されていない場合は実行しない
            if (!this.isSimulatableCreativeType()) {
                return false;
            }
            // シミュレーション可能なメニューが選択されていない場合は実行しない
            return SimulatableMenuTypes.includes(this.selectedMenu.menuType);
        },
        enumerable: false,
        configurable: true
    });
    CompoundCampaignFormModel.prototype.isSimulatableCreativeType = function () {
        return SimulatableCreativeTypes.includes(this.campaign.creativeType);
    };
    CompoundCampaignFormModel.prototype.fetchInsertionOrderBudgets = function () {
        return __awaiter(this, void 0, void 0, function () {
            var budgets, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, InsertionOrderRepository.getBudgets(this.insertionOrderId)];
                    case 1:
                        budgets = _a.sent();
                        this.insertionOrderBudgets = budgets.map(InsertionOrderBudgetFormModel.assign);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1);
                        throw new Error('案件予算の取得に失敗しました');
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CompoundCampaignFormModel.prototype.getNoRejectedCampaignBudgets = function () {
        var campaignBudgets = this.campaign.mergedCampaignBudgets;
        return this.insertionOrderBudgets
            .filter(function (budget) { return budget.summary.requestStatus !== 'rejected'; })
            .map(function (budget) { return getCampaignBudgets(campaignBudgets, budget); })
            .flat();
    };
    CompoundCampaignFormModel.prototype.fetchInventoryRequiredLists = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, InventoryListTargetingModel.fetchInventoryRequiredLists(this.insertionOrderId, this.campaign.menuId)];
                    case 1:
                        result = _a.sent();
                        this.inventoryRequiredLists = result;
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        console.error(e_2);
                        throw new Error('必須Inventoryリストの取得に失敗しました');
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CompoundCampaignFormModel.prototype.fetchInventoryOptionalLists = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, InventoryListTargetingModel.fetchInventoryOptionalLists(this.insertionOrderId, this.campaign.menuId)];
                    case 1:
                        result = _a.sent();
                        this.inventoryOptionalLists = result;
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        console.error(e_3);
                        throw new Error('任意Inventoryリストの取得に失敗しました');
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CompoundCampaignFormModel.prototype.initInventoryList = function () {
        if (this.campaign.advancedSetting.inventoryListOptionalIds.length === 0) {
            this.selectedBlackInventoryListOptionalIds = this.inventoryOptionalLists.blackListItems
                .filter(function (item) {
                return item.usePolicy === InventoryListTargetingUsePolicies.RECOMMENDED;
            })
                .map(function (item) { return item.id; });
        }
        else {
            this.selectedBlackInventoryListOptionalIds = this.campaign.advancedSetting.inventoryListOptionalIds;
        }
    };
    CompoundCampaignFormModel.prototype.setInventoryList = function () {
        this.campaign.advancedSetting.inventoryListOptionalIds = this.selectedBlackInventoryListOptionalIds;
    };
    CompoundCampaignFormModel.prototype.getMenus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, InsertionOrderRepository.getMenus(this.insertionOrderId)];
            });
        });
    };
    CompoundCampaignFormModel.prototype.fetchMenus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getMenus()];
                    case 1:
                        _a.menus = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CompoundCampaignFormModel.prototype.setSelectedMenu = function () {
        return __awaiter(this, void 0, void 0, function () {
            var menus;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.campaign.menuId == null)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.getMenus()];
                    case 1:
                        menus = _a.sent();
                        this.campaign.menu = menus.find(function (m) { return m.id === _this.campaign.menuId; });
                        return [2 /*return*/];
                }
            });
        });
    };
    CompoundCampaignFormModel.prototype.selectMenu = function (menuId) {
        var _this = this;
        if (this.menus.length === 0)
            throw new Error('メニューリストを取得してください');
        this.campaign.menuId = menuId;
        var menu = this.menus.find(function (m) { return m.id === _this.campaign.menuId; });
        // menuの再選択
        this.campaign.selectMenu(menu);
    };
    CompoundCampaignFormModel.prototype.getIpAreaRegions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, MasterApi.fetchIpAreaRegionList({
                            countryId: IP_AREA_JP_ID,
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.items];
                }
            });
        });
    };
    CompoundCampaignFormModel.prototype.fetchIpAreaRegions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getIpAreaRegions()];
                    case 1:
                        _a.ipAreaRegions = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CompoundCampaignFormModel.prototype.save = function () {
        var _a;
        this.isSubmited = true;
        var uploadFile = getUploadFile(this.campaign);
        var params = genRequestParams(this, uploadFile);
        console.log(params);
        try {
            switch ((_a = this.campaign.menu) === null || _a === void 0 ? void 0 : _a.menuType) {
                case MenuTypes.Newspaper:
                case MenuTypes.Pta:
                case MenuTypes.Automobile:
                case MenuTypes.Mansion:
                case MenuTypes.GeoGenome:
                case MenuTypes.Railway:
                case MenuTypes.Retargeting:
                case MenuTypes.CustomGeo:
                case MenuTypes.Office:
                case MenuTypes.Custom:
                    if (this.isNew) {
                        return TemporaryCampaignRepository.create(params);
                    }
                    else {
                        return TemporaryCampaignRepository.update(this.campaign.id, params);
                    }
                case MenuTypes.Geo:
                default:
                    if (this.isNew) {
                        return CampaignRepository.create(params);
                    }
                    else {
                        return CampaignRepository.update(this.campaign.id, params);
                    }
            }
        }
        catch (e) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (e.response.data.item) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var _b = e.response.data, message = _b.message, item = _b.item;
                var error = new CampaignSaveIncompleteError(message);
                error.item = item;
                throw error;
            }
            throw e;
        }
    };
    CompoundCampaignFormModel.prototype.changeStatus = function (campaignId, changeToBoolean) {
        return __awaiter(this, void 0, void 0, function () {
            var changeTo, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        changeTo = changeToBoolean ? 'active' : 'inactive';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, CampaignRepository.changeStatus(campaignId, changeTo)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        console.error(e_4);
                        throw e_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CompoundCampaignFormModel.prototype, "wholePeriodOfBudgets", {
        get: function () {
            return calcWholePeriodOfBudgets(this.insertionOrderBudgets);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * クリエイティブ関連のフィールドを送信しない
     */
    CompoundCampaignFormModel.prototype.disableCreative = function () {
        this.enableCreative = false;
    };
    CompoundCampaignFormModel.prototype.findIpAreaRegion = function (id) {
        return this.ipAreaRegions.find(function (region) { return region.id === id; });
    };
    CompoundCampaignFormModel.prototype.setMenuSetting = function () {
        this.campaign.setMenuSetting(this.profileIds);
    };
    CompoundCampaignFormModel.MAX_DELIVERY_LOCATION_GROUPS = 99;
    return CompoundCampaignFormModel;
}());
export { CompoundCampaignFormModel };
var getUploadFile = function (campaign) {
    var _a;
    var menuSetting;
    switch ((_a = campaign.menu) === null || _a === void 0 ? void 0 : _a.menuType) {
        case MenuTypes.Automobile:
            menuSetting = campaign.menuSetting;
            if (menuSetting.uploadFile.file) {
                return menuSetting.uploadFile.file;
            }
            else {
                return undefined;
            }
        case MenuTypes.CustomGeo:
            menuSetting = campaign.menuSetting;
            if (menuSetting.uploadFile.file) {
                return menuSetting.uploadFile.file;
            }
            else {
                return undefined;
            }
        case MenuTypes.Custom:
            menuSetting = campaign.menuSetting;
            if (menuSetting.uploadFile.file) {
                return menuSetting.uploadFile.file;
            }
            else {
                return undefined;
            }
        default:
            return undefined;
    }
};
